import AnimateWhenCurrencyChange from 'containers/AnimateWhenCurrencyChange'
import ProductGameTile from 'containers/ProductGameTile'
import { shouldShowNotAvailableLocation } from 'pageContainers/Home/components/NotAvailableLocation/utils/shouldShowNotAvailableLocation'
import NotAvailableLocation from 'src/pageContainers/Home/components/NotAvailableLocation'

import Placeholder from '../Placeholder'

import classes from './styles.module.scss'

import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'

type Props = {
  games: GameProduct[]
  categories?: string[]
  isProviderGames?: boolean
  title?: string
  layout?: string
}

function Games(props: Props) {
  const { games, categories, isProviderGames = false, title, layout } = props
  const showNotAvailableLocation = categories && shouldShowNotAvailableLocation(categories) && !isProviderGames

  if (showNotAvailableLocation) {
    return (
      <div className={classes.not_available_location_container}>
        <NotAvailableLocation />
      </div>
    )
  }

  if (!games?.length) {
    return <Placeholder />
  }

  return (
    <div className={classes.root}>
      <AnimateWhenCurrencyChange className={classes.tileContainer} disabledAtTime={2000}>
        {games.map((game, index) => (
          <ProductGameTile
            category={title}
            game={game}
            className={classes.item}
            gameIndex={index + 1}
            key={game.code}
            showFavorite
            layout={layout}
          />
        ))}
      </AnimateWhenCurrencyChange>
    </div>
  )
}

export default Games
